export const MATCH_DOLLAR_SIGN_WORD = /\$\b(\w+)/;

/**
 * Find every word prefixed by '$' in the source
 * and replace each in the exact order of the other provided parameters.
 * @param {string} source - string which contains replaceable words
 * @param {string[]} contentList - strings to replace in the source
 * @returns {string} - formatted string
 */
export const formatText = (source: string = '', ...contentList: string[]) => {
    let result = source;

    for (const content of contentList) {
        result = result.replace(MATCH_DOLLAR_SIGN_WORD, content);
    }

    return result;
};

/**
 * Create a german formatted date string from the parameter
 * @param {string} source - string with date information
 * @returns {string} - formatted date string
 */
export const formatDate = (source: string) => new Date(source).toLocaleDateString('de');
